import React from 'react'
import PropTypes from 'prop-types'
import { FormattedNumber } from 'react-intl'
import { Copy } from '@elparking/components'
import { DISTANCE_MILES_PER_METRE, DISTANCE_FOOTS_PER_MILE } from 'commons/js/constants'
import currentCountry from 'commons/js/country'
import CountrySwitch from 'commons/js/components/CountrySwitch'

const DistanceFoots = ({ distance: distanceInMeters, ...restProps }) => {
    const distanceInMiles = DISTANCE_MILES_PER_METRE * distanceInMeters
    const formattedProps = distanceInMiles < 0.1
        ? { value: distanceInMiles * DISTANCE_FOOTS_PER_MILE }
        : { value: distanceInMiles }
    const unit = distanceInMiles < 0.1
        ? 'ft'
        : 'mi'
    return <Copy padding='0' as='span' {...restProps}>
        <FormattedNumber style='decimal' maximumFractionDigits={2} {...formattedProps} />
        {''}
        {unit}
    </Copy>
}

DistanceFoots.propTypes = {
    distance: PropTypes.number,
}

const DistanceMetres = ({ distance: distanceInMeters, ...restProps }) => {
    const formattedProps = distanceInMeters >= 1E3
        ? { value: distanceInMeters / 1E3 }
        : { value: distanceInMeters }
    const unit = distanceInMeters >= 1E3
    ? 'km'
    : 'm'
    return <Copy padding='0' as='span' {...restProps}>
        <FormattedNumber style='decimal' maximumFractionDigits={2} {...formattedProps} />
        {''}
        {unit}
    </Copy>
}

DistanceMetres.propTypes = {
    distance: PropTypes.number,
}

const Distance = (props) => (
    <CountrySwitch
      usa={DistanceFoots}
      esp={DistanceMetres}
      country={currentCountry}
      {...props}
    />
)

Distance.propTypes = {
    distance: PropTypes.number,
}

export default Distance
